
































import { Vue, Component } from "vue-property-decorator";
import huilianyiService from "@/service/huilianyiService";
@Component({
  name: "huilianyi",
  components: {
    
  },
})
  export default class extends Vue {
    approvalList = [];
    mounted() {
      this.searchapproval();
    }
    searchapproval() {
       let __self = this;
       huilianyiService.searchapprovals().then((res:any) => {
         __self.approvalList = res.result;
       });
    }
     booking(data:any) {
       let __self = this;
       const id = data.companyId + data.approvalCode;
       huilianyiService.booking(id).then((res:any) => {
         if (res.isSucc) {
          const url = res.result.booking_url; 
           location.href = __self.getBookingUrl(url);
         }
       });
    }
    getBookingUrl(url:string){      
      // 获取当前页面的协议和域名
      const currentDomain = `${window.location.protocol}//${window.location.host}`;
      // 提取查询参数部分（?及其后面的内容）
      const queryIndex = url.indexOf('?');
      const queryPart = queryIndex !== -1 ? url.substring(queryIndex) : '';
      const booking_url = `${currentDomain}/mall/flight${queryPart}`;
      return booking_url;
    }
    back(): void {
      history.back();
    }
  }
